import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const successPlaceDeliveryNote = createAction(ACTION.PLACE_DELIVERY_NOTE.SUCCESS);
